export const percentual = 100;
export const minimumWeight = 0;
export const freeShippingValue = 400;
export const maximumWeight = 10;
export const baseShippingValue = 30;
export const extraWeightForShipping = 5;
export const extraShippingFee = 7;
export const minimumPurchaseValue = 0;